module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-10.2b76b019.png";